import React, { useContext, useState, useEffect } from 'react';
import { FaCamera, FaUser } from 'react-icons/fa'; 
import { AuthContext } from '../../../../app/providers/AuthContext';
import { toast, Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchWrapper } from '../../../../shared/api/fetchWrapper';

function ProfileContent() {
  const { user } = useContext(AuthContext);
  const [profileImage, setProfileImage] = useState('');
  const [profileData, setProfileData] = useState({
    name: user?.uname || '',
    email: user?.email || '',
    phone: user?.phone || '',
    title: user?.title || '',
    intro: user?.intro || ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
      setProfileData((prev) => ({ ...prev, profileImageFile: file }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append('email', profileData.email);
    formData.append('uname', profileData.name);
    formData.append('phone', profileData.phone);
    formData.append('title', profileData.title);
    formData.append('intro', profileData.intro);
    formData.append('token', user?.token || localStorage.getItem('token'));
    
    if (profileData.profileImageFile) {
      formData.append('pp_path', profileData.profileImageFile);
    }
  
    try {
      const response = await fetchWrapper(process.env.REACT_APP_UPDATE_MEMBER, formData);
  
      if (response) {
        toast.success('Profil bilgileriniz başarıyla güncellendi.', {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        fetchProfilePicture(); // Fetch the profile picture after successful update
      } else {
        toast.error(`Error: ${response.success}`, {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error('An error occurred while updating the profile.', {
        position: "top-right",
      });
    }
  };
  



  const fetchProfilePicture = async () => {
    const apiURL = process.env.REACT_APP_API_URL
    try {
      const response = await fetch(`${apiURL}?token=${user?.token || localStorage.getItem('token')}&process=100019354`, {
        method: 'GET',
      });
      if (response) {
        const imageBlob = await response.blob();
        const imageUrl = URL.createObjectURL(imageBlob);
        setProfileImage(imageUrl); // Display the fetched profile picture
      } else {
        toast.error('Failed to load profile picture.', {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error('Error fetching profile picture:', error);
      toast.error('An error occurred while fetching the profile picture.', {
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    fetchProfilePicture(); // Fetch profile picture on component mount
  }, []);

  return (
    <div className="h-full flex flex-col items-center bg-gray-700 text-white p-6 transition-colors duration-200">
            <ToastContainer /> {/* Add this to render toasts */}
      <div className="flex flex-col items-center mb-8">
        <div className="relative">
          {profileImage ? (
            <img
              src={profileImage}
              alt="Profile"
              className="w-32 h-32 rounded-full object-cover border-4 border-gray-500"
            />
          ) : (
            <div className="w-32 h-32 rounded-full bg-gray-500 flex items-center justify-center">
              <FaUser className="text-white text-4xl" />
            </div>
          )}
          <label
            htmlFor="profileImage"
            className="absolute bottom-0 right-0 p-2 bg-gray-800 rounded-full cursor-pointer"
          >
            <FaCamera className="text-white" />
            <input
              type="file"
              id="profileImage"
              accept="image/*"
              className="hidden"
              onChange={handleProfileImageChange}
            />
          </label>
        </div>
        <p className="mt-4 text-sm text-gray-300">
          Click the icon to change your profile picture
        </p>
      </div>

      <form className="w-full max-w-md" onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-400 text-sm font-bold mb-2">Name</label>
          <input
            type="text"
            name="name"
            value={profileData.name}
            onChange={handleInputChange}
            className="w-full px-3 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-400 text-sm font-bold mb-2">Email</label>
          <input
            type="email"
            name="email"
            value={profileData.email}
            onChange={handleInputChange}
            className="w-full px-3 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-400 text-sm font-bold mb-2">Phone</label>
          <input
            type="text"
            name="phone"
            value={profileData.phone}
            onChange={handleInputChange}
            className="w-full px-3 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-400 text-sm font-bold mb-2">Title</label>
          <input
            type="text"
            name="title"
            value={profileData.title}
            onChange={handleInputChange}
            className="w-full px-3 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-400 text-sm font-bold mb-2">Intro</label>
          <textarea
            name="intro"
            value={profileData.intro}
            onChange={handleInputChange}
            className="w-full px-3 py-2 bg-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex justify-center mt-6">
          <button
            type="submit"
            className="px-6 py-2 bg-[#1F2A37] ext-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}

export default ProfileContent;
